import { Injectable } from '@angular/core';
import { sessionKey } from '../../shared/constants/storage-key-constants';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  storage: Storage;
  constructor() {
    this.storage = window.sessionStorage;
  }

  /**
   *
   *
   * @name setItem
   * @description Function to store data in session storage
   * @template T
   * @param key
   * @param value
   * @memberof SessionStorageService
   */
  setItem<T>(key: string, value: T): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  /**
   *
   *
   * @name getItem
   * @description Function to retrieve data from session storage
   * @template T
   * @param key
   * @returns
   * @memberof SessionStorageService
   */
  getItem<T>(key: string): T {
    return JSON.parse(this.storage.getItem(key));
  }

  /**
   *
   *
   * @name removeItem
   * @description Function to remove data from session storage
   * @param key
   * @memberof SessionStorageService
   */
  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  /**
   * @name clear
   * @description Function to clear all data from session storage
   * @memberof SessionStorageService
   */
  clear(): void {
    this.storage.clear();
  }

  /**
   * @name setSessionId
   * @description set sessionid for user
   * @memberof SessionStorageService
   */
  setSessionInfo(sessionInfo?: string) {
    if (sessionInfo) {
      this.setItem(sessionKey, sessionInfo);
    } else {
      this.getSessionInfo();
    }
  }

  getSessionInfo(): string {
    let sesionId: string = this.getItem(sessionKey);
    if (!sesionId) {
      sesionId = UtilityService.getSessionId();
      this.setItem(sessionKey, sesionId);
    }
    return sesionId;
  }
}
